<template>
  <div id="app">
    <div class="full-section">
    <Header></Header>
    <div class="body-middle">
      <router-view/>
    </div>
    </div>
  </div>
</template>
<script>
    import Header from "@/components/header.vue";

    export default {
        name: "home",
        components: {
            Header,
        },
        data() {
            return {

            };
        },
        methods: {

        },
        mounted() {
        },
    };
</script>
<style lang="scss">

</style>
